import { WriteRequest } from "~/backendApis/foundation/WriteRequest"

interface Params {
  mainSmallJobCategoryId: number
  subSmallJobCategoryId: number | null
}

export class ChangeJobWriteRequest extends WriteRequest<void> {
  private readonly endpoint: string = "/user_profile/user/edit/job/change"
  private readonly params: Params

  constructor(params: Params) {
    super()
    this.params = params
  }

  public post(): Promise<void> {
    return this.apiClient.post(this.endpoint, this.params)
  }
}
